module.exports = __webpack_public_path__ + "static/media/plus.5e901602.svg";